import type { Clip } from "./clip.js";

/** Opener styles that fill the whole frame; the rest sit over the running video. */
export const FULLSCREEN_OPENERS = ["card", "blur", "split", "type"] as const;
export const isFullscreenOpener = (style: string): boolean => (FULLSCREEN_OPENERS as readonly string[]).includes(style);

export const openerActive = (clip: Clip): boolean => clip.hook.enabled && clip.hook.text.trim().length > 0;

/** How long the opener waits before it comes in (0 when there is no opener). */
export const openerDelayMs = (clip: Clip): number => (openerActive(clip) ? clip.hook.delayMs : 0);

/** How long the video waits behind a full-screen opener that plays before the speech: its delay plus its length (0 when the opener overlays the speech). */
export function openerHoldMs(clip: Clip): number {
  return openerActive(clip) && isFullscreenOpener(clip.hook.style) && clip.hook.mode === "intro" ? clip.hook.delayMs + clip.hook.durationMs : 0;
}

/** Splits "*word*" markup into runs so marked words can take the accent colour. */
export function accentRuns(text: string): { text: string; accent: boolean }[] {
  const out: { text: string; accent: boolean }[] = [];
  const re = /\*([^*]+)\*/g;
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push({ text: text.slice(last, m.index), accent: false });
    out.push({ text: m[1], accent: true });
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push({ text: text.slice(last), accent: false });
  return out;
}

/** The title without the *accent* markup. */
export const plainTitle = (text: string): string => text.replace(/\*([^*]+)\*/g, "$1");
